import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initializeMsalAndHandleRedirect } from './utils/msalRedirectHandler';

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

// Initialize MSAL and handle any redirect BEFORE React renders
// This ensures MSAL is ready and prevents "interaction_in_progress" errors
initializeMsalAndHandleRedirect().then(() => {
  console.log('[App] MSAL initialized and redirect handled, starting React app...');
  
  // Note: React.StrictMode in development causes double-renders and can trigger
  // "interaction_in_progress" errors. In production builds, StrictMode is ignored.
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}).catch((error) => {
  console.error('[App] Error initializing MSAL:', error);
  
  // Still render the app even if there was an error
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}); 